var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import classnames from 'classnames';
const RadioButton = props => {
    const { className, label, checked, onChangeHandler, name, value } = props, rest = __rest(props, ["className", "label", "checked", "onChangeHandler", "name", "value"]);
    return (React.createElement("label", { className: classnames(className, 'RadioButton', {
            'RadioButton--checked': checked
        }) },
        label,
        React.createElement("input", Object.assign({ value: value, name: name }, rest, { type: "radio", checked: checked, onChange: onChangeHandler })),
        React.createElement("span", { className: 'RadioButton__Checkmark' })));
};
export default RadioButton;
